/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'ai-mate.chat-error-banner.description': 'Chathistorikken din lagres i opptil 30 dager.',
  'ai-mate.chat-error-banner.title': 'Start ny chat',
  'ai-mate.chat-error.description': 'Prøv å <btn>laste inn chatten på nytt</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Du har nådd maksimalt antall forespørsler. Prøv igjen senere.',
  'ai-mate.chat-error.rate-limited-title': 'For mange forespørsler',
  'ai-mate.chat-error.rovo-inactive-description':
    'Rovo er visst ikke aktivert på nettstedet ditt. <link>Konfigurere Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo er inaktiv',
  'ai-mate.chat-error.title': 'Vi vet ikke hva som gikk galt',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Spør AI om dette',
  'highlight-actions.rovo-chat-explain-option.text': 'Forklar',
  'highlight-actions.rovo-chat-explain-prompt': 'Forklar dette: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chat-anbefalinger',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Åpne nettprat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Oppsummer',
  'highlight-actions.rovo-chat-summarize-prompt': 'Oppsummer dette {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Rull mot venstre',
  'horizontal-scroll-container.scroll-right': 'Rull mot høyre',
};
